import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle(event) {
    if (event.target.checked) {
      this.dispatch("create")
    } else {
      this.dispatch("destroy")
    }
  }
}
